import React from 'react';
import { Container, Flex, FlexItem, H3, Radio, Text } from '@erecruit/ui-kit';
import { AppearanceContext, AppearanceThemes } from '@erecruit/modules';
import { Intl } from '@erecruit/core';

import darkThemeSrc from './darkTheme.png';
import lightThemeSrc from './lightTheme.png';

const { FormattedMessage } = Intl;

export const Appearance: React.FunctionComponent = () => {
  return (
    <AppearanceContext.Consumer>
      {({ appearance, update }) => (
        <>
          <H3 padding={[2, 0]} color="headerPrimary">
            <FormattedMessage
              id={messageIds.vms.settings.appearance.chooseTheme}
            />
          </H3>
          <Flex gutter={5}>
            <FlexItem flex={0} gutter={3} gutterDirection="vertical">
              <Container background="transparent">
                <img src={lightThemeSrc} alt="Light theme" />
              </Container>
              <Container background="transparent" gutter={2}>
                <Text inline>
                  <FormattedMessage
                    id={messageIds.vms.settings.appearance.lightTheme}
                  />
                </Text>
                <Radio
                  checked={appearance?.theme === AppearanceThemes.Light}
                  onClick={() => update({ theme: AppearanceThemes.Light })}
                />
              </Container>
            </FlexItem>
            <FlexItem flex={0} gutter={3} gutterDirection="vertical">
              <Container background="transparent">
                <img src={darkThemeSrc} alt="Dark theme" />
              </Container>
              <Container background="transparent" gutter={2}>
                <Text inline>
                  <FormattedMessage
                    id={messageIds.vms.settings.appearance.darkTheme}
                  />
                </Text>
                <Radio
                  checked={appearance?.theme === AppearanceThemes.Dark}
                  onClick={() => update({ theme: AppearanceThemes.Dark })}
                />
              </Container>
            </FlexItem>
          </Flex>
        </>
      )}
    </AppearanceContext.Consumer>
  );
};
